/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcedureBalanceIntegrationViewModel } from './procedureBalanceIntegrationViewModel';

export interface VisitBalanceIntegrationViewModel {
  /**
   * Visit Number
   */
  referenceNumber?: number;
  /**
   * Total Procedure Charge Amount
   */
  procedureAmount?: number;
  /**
   * Total Payments
   */
  paidAmount?: number;
  /**
   * Total Adjustments
   */
  adjustmentAmount?: number;
  /**
   * Current patient balance
   */
  patientBalance?: number;
  /**
   * Current insurance balance
   */
  insuranceBalance?: number;
  /**
   * Patient or Insurance Responsible
   */
  responsibleParty?: string | null;
  /**
   * Estimated patient balance for insurance responsible visits
   */
  estimatedPatientBalance?: number | null;
  /**
   * Hold Visit
   */
  holdVisit?: boolean | null;
  /**
   * Visit date, for reference in external systems only (optional)
   */
  visitDate?: string | null;
  /**
   * External Id, max length 50
   */
  externalId?: string | null;
  procedures?: Array<ProcedureBalanceIntegrationViewModel> | null;
}
